import { useCallback } from "react";
import type { DashboardModelT } from "../../schema/dashboard";
import { useDeleteRemoteDashboardCallback } from "../api/dashboard";

export const useDashboardDeleteCallback = () => {
  const deleteRemoteDashboard = useDeleteRemoteDashboardCallback();
  return useCallback(
    (dashboard: DashboardModelT) => deleteRemoteDashboard(dashboard.projectId, dashboard.id),
    [deleteRemoteDashboard],
  );
};
